import React from 'react';

const ClaimedClassmatesContext = React.createContext();

export default ClaimedClassmatesContext;
